module.exports = new __parcel__URL__("crash-bandicoot-warped.d3b5b930.jpg").toString();